export const premiumBenefitCategories = [
  'refresh_factor',
  'team_limit',
  'character_limit',
] as const

export type PointDistribution = {
  otherOrLegacy: number
  own: number
  total: number
}

export type PointsSpentByCategory = {
  [K in PremiumBenefitCategory]: PointDistribution
}

export const PREMIUM_BENEFIT_CONFIG = {
  refresh_factor: { min: 1, max: 30, start: 0, step: 1 },
  team_limit: { min: 1, max: 20, start: 0, step: 1 },
  character_limit: { min: 30, max: 100, start: 20, step: 10 },
}

type PremiumBenefitCategory = typeof premiumBenefitCategories[number]
export default PremiumBenefitCategory
